module.exports = __webpack_public_path__ + "static/media/checked.3a43fbdb.svg";